import React, { useEffect, useState } from "react";
import {
  Alert,
  AlertTitle,
  Button,
  Chip,
  CircularProgress,
  Typography,
  IconButton,
  DialogContent,
  TextField,
  InputAdornment,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import { Add, CalendarMonth, Downloading, Refresh } from "@mui/icons-material";
import { saveAs } from "file-saver";
import Dialog from "@mui/material/Dialog";
import moment from "moment";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { tableTheme } from "../store/helpers/common_functions";
import { GridSearchIcon } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import ControlledButton from "components/UI/ControlledButton";

const SerializeObject = (obj, prefix) => {
  let str = [],
    p;

  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? prefix + "[" + p + "]" : p;
      const v = obj[p];
      if (typeof v === "object") {
        str.push(SerializeObject(v, k));
      } else if (typeof v !== "function") {
        str.push(
          encodeURIComponent(k) + "=" + encodeURIComponent(v?.toString() ?? "")
        );
      }
    }
  }

  return str.join("&");
};

let loadPdf = false;
let loadExcel = false;

const DatatableComponent = ({
  statusFilter,
  columns,
  pdf,
  excel,
  DateRangePicker,
  url,
  fileName,
  title,
  processData,
  elevation,
  customToolbarSelect,
  onRowClick,
  onRowSelectionChange,
  onAddNew,
  selectableRows,
  order,
  addButton,
  showDatePicker,
  onReport,
  printable,
  search,
  pagination,
  viewColumns,
  searchfield,
  className,
  expandableRows,
  renderExpandableRow,
  initialData,
  hideToolbar,
  onCalendarChange,
  onMeeting,
  onMinutes,
  submitReport,
  onSubmitReport,
  subMenuCode,
  checkSubMenuPermission,
  checkActionPermission,
  raciChart,
  onRaciChart,
  actionCode,
  // New prop for status filter
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [sortOrder, setSortOrder] = useState(order);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [error, setError] = useState();
  const [errorStatus, setErrorStatus] = useState();
  const [tableState, setTableState] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const [columns0, setColumns0] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [expandedRows, setExpandedRows] = useState([]);

  const [range, setRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });
  const [anchorEl, setAnchorEl] = useState(null);

  const settings = secureLocalStorage.getItem("systemSettings");
  const settingsInfo = JSON.parse(settings);
  const mainBackground = settingsInfo?.mainBackground;

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (v) => {
    if (v === "pdf") {
      loadPdf = true;
      reload();
    } else if (v === "excel") {
      loadExcel = true;
      reload();
    }
    setAnchorEl(null);
  };

  const reload = () => setRefresh((refresh) => refresh + 1);

  useEffect(() => {
    setSortOrder(order);
  }, [order]);

  const preSetData = (reqData) => {
    if (reqData) {
      if (processData) {
        const { data, recordsFiltered, page } = processData(reqData);
        setError(null);
        setData(data);
        setCount(recordsFiltered);
        setPage(page);
      } else {
        setError(null);
        setData(reqData.data);
        setCount(reqData.recordsFiltered);
        setPage(reqData.page);
      }
    }
  };

  const onTableChange = (action, tableState) => {
    switch (action) {
      case "changePage":
        setPage(tableState.page);
        tableChange(tableState);
        break;
      case "search":
        break;
      case "searchfield":
        setTableState(tableState);
        tableChange(tableState);
        break;
      case "sort":
        setTableState(tableState);
        tableChange(tableState);
        break;

      case "expandRow":
        var rowsExpanded = tableState.expandedRows.data.map(
          (item) => item.index
        );

        if (rowsExpanded.length > 1) {
          // limiting would go here
          rowsExpanded = rowsExpanded.slice(-1);
        }

        setExpandedRows((prevState) => ({
          expandedRows: rowsExpanded,
        }));

        break;
      default:
        // Optionally handle unknown actions or do nothing
        break;
    }
  };
  const tableChange = (tableState) => {
    let cols = {};
    for (let o in columns) {
      let obj = columns[o];
      let n = obj.data ?? obj.name;
      if (n && obj?.options?.filter !== false) {
        cols[n] = {
          data: n,
        };
      }
    }

    let object = {
      columns: cols,
    };

    if (tableState.searchText) {
      object.search = {
        value: tableState.searchText,
      };
    }

    if (tableState.sortOrder && tableState.sortOrder.name) {
      const obs = columns.find((v) => v.name === tableState.sortOrder.name);
      object.order = [
        {
          column:
            obs?.data ?? tableState.sortOrder.data ?? tableState.sortOrder.name,
          dir: tableState.sortOrder.direction,
        },
      ];
    }

    const append = SerializeObject(object);
    changePage(tableState.page, tableState.sortOrder, append);
  };

  const fetchData = async (rows, newPage) => {
    setLoading(true);
    const res = await xhrRequest(
      newPage ?? page,
      sortOrder,
      null,
      rows ?? rowsPerPage
    );
    preSetData(res);
    setLoading(false);
    return res;
  };

  // const fetchData = async (
  //   rows?: number | null | undefined,
  //   newPage?: number | null | undefined
  // ) => {
  //   setLoading(true);
  //   const res = await xhrRequest(newPage ?? page, null, null, rows);
  //   preSetData(res);
  //   setLoading(false);
  //   return res;
  // };

  useEffect(() => {
    setPage(0);
    if (tableState) {
      tableChange(tableState);
    } else {
      fetchData(undefined, 0).then();
    }
  }, [url, refresh]);

  // mock async function
  const xhrRequest = async (page, sortOrder = null, append = null, rows) => {
    let config = {
      headers: { "access-token": secureLocalStorage.getItem("token") },
    };
    let char = url.includes("?") ? "&" : "?";
    const rows2 = rows ?? rowsPerPage ?? 0;
    let URL = `${url}${char}start=${
      (page ?? 0) * rows2
    }&length=${rows2}&${append}`;

    let isPdf = false;

    if (showDatePicker && range.startDate && range.endDate) {
      URL = `${URL}&startDate=${moment(range.startDate).format(
        "YYYY-MM-DD"
      )}&endDate=${moment(range.endDate).format("YYYY-MM-DD")}`;
    }

    if (loadPdf || loadExcel) {
      isPdf = true;
      URL = `${URL}&${loadExcel ? "excel" : "pdf"}=1`;
      loadPdf = false;
      loadExcel = false;
    }

    try {
      if (isPdf) {
        config = { ...config, responseType: "blob" };
      }
      const { data } = await axios.get(URL, config);
      if (isPdf) {
        const file = new Blob([data], {
          type: URL.includes("pdf=1")
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        saveAs(
          file,
          URL.includes("pdf=1")
            ? `${fileName ?? "report"}.pdf`
            : `${fileName ?? "report"}.xlsx`
        );
        return null;
      }
      return data;
    } catch (e) {
      const err = e;
      if (err?.data) {
        setErrorStatus(err.status ?? 500);
        setError(err.data?.message);
      } else {
        setErrorStatus(500);
        setError("Connection refused");
      }
      setLoading(false);
      return null;
    }
  };

  const changePage = (newPage, sortOrder, append) => {
    setLoading(true);
    setPage(newPage);
    xhrRequest(newPage, sortOrder, append, rowsPerPage).then((res) => {
      preSetData(res);
      setLoading(false);
    });
  };
  const location = useLocation();

  const defaultOptions = {
    search: search ?? true,
    filter: false,
    viewColumns: viewColumns ?? true,
    filterType: "dropdown",
    enableNestedDataAccess: ".",
    elevation: elevation ?? 0,
    serverSide: true,
    count: count,
    onRowClick,
    customToolbarSelect,
    onRowSelectionChange,
    download: false,
    print: printable ?? false,
    page: page,
    rowsPerPage: rowsPerPage,
    selectableRowsHeader: selectableRows ?? false,
    pagination: pagination ?? true,
    showDatePicker: showDatePicker ?? true,
    expandableRows: expandableRows ?? false,
    renderExpandableRow: renderExpandableRow,
    expandableRowsOnClick: true,
    rowsExpanded: expandedRows,
    onRowExpansionChange: (_, allRowsExpanded) => {
      const newExpandedRows = allRowsExpanded
        .slice(-1)
        .map((item) => item.index);
      if (JSON.stringify(newExpandedRows) !== JSON.stringify(expandedRows)) {
        setExpandedRows(newExpandedRows);
      }
    },
    customToolbar: () => {
      let button = undefined;

      if (statusFilter) {
        button = (
          <>
            <TextField
              select
              label="Filter by Status"
              value={statusFilter.selectedStatus}
              onChange={(e) => statusFilter.onChange(e.target.value)}
              variant="outlined"
              size="small"
              style={{ width: "200px", marginRight: "10px" }}
              SelectProps={{
                native: true,
              }}
            >
              {statusFilter.options.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </TextField>
            {button}
          </>
        );
      }

      if (searchfield) {
        button = (
          <>
            {button}
            <div>
              <TextField
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    backgroundColor: "#f5f5f5",
                    transition: "0.3s",
                    "& fieldset": {
                      borderColor: "#ddd",
                    },
                    "&:hover fieldset": {
                      borderColor: "#aaa",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused": {
                      boxShadow: "none",
                    },
                  },
                  "& .MuiInputAdornment-root": {
                    color: "#888",
                  },
                }}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  onTableChange("searchfield", { searchText: e.target.value });
                }}
                placeholder="Search"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <GridSearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </>
        );
      }

      // Add New Button (Third)
      if (addButton || onAddNew) {
        button = (
          <>
            {button}
            <span className={"ml-5"}>
              <ControlledButton
                className="text-red-800"
                variant="contained"
                onClickAction={onAddNew}
                label={"Add new"}
                icon={<Add />}
                subMenuCode={subMenuCode}
                checkSubMenuPermission={checkSubMenuPermission}
                checkActionPermission={checkActionPermission}
                actionCode={actionCode}
                type="button"
              />
            </span>
          </>
        );
      }

      if (showDatePicker) {
        button = (
          <>
            {button}
            <IconButton
              onClick={() => {
                setShowCalendar((show) => !show);
              }}
            >
              <CalendarMonth />
            </IconButton>
          </>
        );
      }

      if (onMeeting) {
        const isActive = location.pathname === "/admin/meeting";
        button = (
          <>
            {button}
            <Link to="/admin/meeting" className="text-decoration-none">
              <Button
                className="text-red-800"
                variant="contained"
                sx={{
                  backgroundColor: isActive ? mainBackground : "#ffffff",
                  color: isActive ? "#ffffff" : mainBackground,
                  "&:hover ": {
                    backgroundColor: mainBackground,
                    color: "#ffffff",
                  },
                }}
              >
                <i className="fa fa-calendar fa-md me-1" />
                <span className="ml-2">Meeting</span>
              </Button>
            </Link>
          </>
        );
      }

      if (onMinutes) {
        const isActive = location.pathname === "/admin/minutes";
        button = (
          <>
            {button}
            <Link to="/admin/minutes" className="text-decoration-none">
              <Button
                className="text-red-800"
                variant="contained"
                sx={{
                  backgroundColor: isActive ? mainBackground : "#ffffff",
                  color: isActive ? "#ffffff" : mainBackground,
                  "&:hover ": {
                    backgroundColor: mainBackground,
                    color: "#ffffff",
                  },
                }}
              >
                <i className="fa fa-users fa-md me-1" />
                <span className="">Minutes</span>
              </Button>
            </Link>
          </>
        );
      }

      if (submitReport) {
        button = (
          <>
            {button}
            <span className={"ml-2"}>
              <Button
                variant={"contained"}
                size={"small"}
                style={{
                  backgroundColor: mainBackground,
                }}
                onClick={onSubmitReport}
              >
                Submit Report
              </Button>
            </span>
          </>
        );
      }
      if (raciChart) {
        button = (
          <>
            {button}
            <span className={"ml-2"}>
              <Button
                variant={"contained"}
                size={"small"}
                style={{
                  backgroundColor: mainBackground,
                }}
                onClick={onRaciChart}
              >
                Generate report
              </Button>
            </span>
          </>
        );
      }
      if (pdf || excel) {
        button = (
          <>
            {button}
            <span className={"ml-2"}>
              <Button
                id="basic-button"
                variant={"outlined"}
                size={"small"}
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                startIcon={<Downloading />}
              >
                Export
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {pdf && (
                  <MenuItem
                    value={"pdf"}
                    onClick={() => {
                      if (onReport) {
                        onReport("pdf");
                      } else {
                        handleClose("pdf");
                      }
                    }}
                  >
                    PDF
                  </MenuItem>
                )}
                {excel && (
                  <MenuItem
                    value={"excel"}
                    onClick={() => {
                      if (onReport) {
                        onReport("excel");
                      } else {
                        handleClose("excel");
                      }
                    }}
                  >
                    Excel
                  </MenuItem>
                )}
              </Menu>
            </span>
          </>
        );
      }

      if (onCalendarChange) {
        button = (
          <>
            {button}
            <Button
              className="text-red-800"
              variant="contained"
              sx={{
                backgroundColor: mainBackground,
                "&:hover ": { backgroundColor: mainBackground },
              }}
              onClick={onAddNew}
              startIcon={<CalendarMonth />}
            >
              Calendar
            </Button>
          </>
        );
      }

      return (
        <div className={"flex items-center gap-2 justify-end p-2"}>
          {" "}
          {button}{" "}
        </div>
      );
    },
    disableToolbarSelect: true, // Disables toolbar selection options
    rowsPerPage: rowsPerPage,
    selectableRows: selectableRows ?? "none",
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
      fetchData(numberOfRows);
    },
    rowsPerPageOptions: [20, 100, 500, 1000, 1500],
    sortOrder: sortOrder,
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    textLabels: {
      body: error
        ? {
            noMatch: (
              <div className={"text-left"}>
                <Alert
                  severity="error"
                  action={
                    <Button
                      endIcon={<Refresh />}
                      color="inherit"
                      onClick={() => fetchData()}
                    >
                      Refresh{" "}
                    </Button>
                  }
                >
                  <AlertTitle>Error ({errorStatus ?? ""})</AlertTitle>
                  {error} — <strong>check it out!</strong>
                </Alert>
              </div>
            ),
          }
        : undefined,
    },
    onTableChange,
    setRowProps: (row) => {
      const isHighlighted = row[6] === "true";
      return {
        style: {
          backgroundColor: isHighlighted ? "rgba(211, 211, 211, 0.9)" : "",
        },
      };
    },
    options: {
      viewColumns: false,
    },
    // onRowClick: (rowData, rowMeta) => {
    //   if (onRowClick) {
    //     const rowIndex = rowMeta.dataIndex;
    //     const row = data[rowIndex]; // Get the full row data
    //     onRowClick(row); // Pass the row data to the parent component
    //   }
    // },
  };

  useEffect(() => {
    let newCols = [
      {
        name: "ID",
        label: "#",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let rowIndex = Number(tableMeta.rowIndex) + 1;
            return (
              <Chip
                label={
                  rowIndex +
                  tableMeta.tableState.page * tableMeta.tableState.rowsPerPage
                }
                style={{
                  backgroundColor: "transparent",
                  fontFamily: "lexend,sans-serif",
                  fontSize: "15px",
                }}
              />
            );
          },
        },
      },
      ...columns,
    ];
    newCols = newCols.map((v) => ({
      label: <span className={"fw-bold text-uppercase"}>{v.label}</span>,
      ...v,
    }));

    setColumns0(newCols);
  }, [columns]);

  return (
    <div className={"relative" + className}>
      {loading ? (
        <div
          className={
            "absolute h-full w-full top-0 left-0 flex justify-center items-center"
          }
        >
          <div
            className={"bg-white p-3 rounded shadow text-center"}
            style={{ zIndex: 200 }}
          >
            <div>
              <CircularProgress color={"success"} />
            </div>
            <span>
              <Typography>Loading ....</Typography>
            </span>
          </div>
        </div>
      ) : null}
      <ThemeProvider
        theme={tableTheme({
          hideToolbar,
        })}
      >
        <MUIDataTable
          title={
            <div>{title}</div> ?? (
              <Typography variant="h6">
                List
                {loading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            )
          }
          data={initialData ?? data}
          columns={columns0}
          options={defaultOptions}
        />
      </ThemeProvider>
      {showCalendar && (
        <Dialog open={showCalendar} onClose={() => setShowCalendar(false)}>
          <DialogContent>
            <DateRangePicker
              ranges={[range]}
              showMonthAndYearPickers={false}
              onChange={(ranges) => {
                setRange(ranges.selection);
                reload();
              }}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default DatatableComponent;
